import { navigate } from "gatsby"
import Cookies from "js-cookie"
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react"
import { getHeaderAccessToken, getHeaderTaasToken, getUserDetails, getBauAccessToken } from "../services/auth"
import { useLoadingData } from "./LoadingContext"

export type TokenDetails = {
  access_token: string | null
  id_token: string | null
  refresh_token: string | null
  scope: string | null
  token_type: string | null
}

//APIM Token object for TAAS//
export type TaasTokenDetails = {
  access_token: string | null
  scope: string | null
  token_type: string | null
  expires_in: string | null
}
export type BauTokenDetails = {
  access_token: string | null
  scope: string | null
  token_type: string | null
  expires_in: string | null
}
export type UserDetails = {
  sub: string | null
  name: string | null
  nickname: string | null
  picture: string | null
  email: string | null
  email_verified: string | null
  phone_number_verified: string | null
  national_id_number: string | null
  national_id_type: string | null
}

type IContext = {
  isLoggedIn: boolean
  header_access_token: string | undefined
  tokenDetails: TokenDetails | undefined
  taasTokenDetails: TaasTokenDetails | undefined
  bauTokenDetails: BauTokenDetails | undefined
  header_tass_token: string | undefined
  header_bau_token: string | undefined
  updateToken: () => void
  updateTokenDetails: () => void
  updateTass: () => void
  updateTassDetails: () =>void
  login: (headerAccessToken: string) => void
  logout: () => void
  userInfo: UserDetails | undefined
  
}

const AuthContext = createContext<IContext>({
  isLoggedIn: false,
  header_access_token: undefined,
  tokenDetails: undefined,
  taasTokenDetails: undefined,
  bauTokenDetails: undefined,
  header_tass_token:  undefined,
  header_bau_token:  undefined,
  updateToken: () => {},
  updateTokenDetails: () => {},
  updateTass: () => {},
  updateTassDetails: () =>{},  
  login: () => {},
  logout: () => {},
  userInfo: undefined
 
})

export const useAuthContext = () => useContext(AuthContext)

type AuthProviderProps = {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const isSsr = typeof window === "undefined"
  const localData = !isSsr ? localStorage.getItem("userData") : null
  const { isLoading, setLoading } = useLoadingData()
  const userToken = localData ? JSON.parse(localData).header_access_token : null
  const [header_access_token, setToken] = useState<string | undefined>()
  const [tokenDetails, setTokenDetails] = useState<TokenDetails | undefined>()
  const [taasTokenDetails, setTaasTokenDetails] = useState<TaasTokenDetails | undefined>()
  const [bauTokenDetails, setBauTokenDetails] = useState<BauTokenDetails | undefined>()
  const [header_tass_token, setTass] = useState<string | undefined>()
  const [header_bau_token, setBauToken] = useState<string | undefined>()
  const [userInfo, setUserInfo] = useState<UserDetails | undefined> ()
  // useEffect(() => {
  //   updateToken()
  // }, [])

  const login = useCallback((headerAccessToken: string) => {
    Cookies.set("header_access_token", headerAccessToken || "", {
      expires: 36500,
    });
    Cookies.set("header_tass_token", headerAccessToken || "", {
      expires: 3600,
    });
    Cookies.set("header_bau_token", headerAccessToken || "", {
      expires: 3600,
    });
  }, [])

  const updateTokenDetails = async () => {
    if (header_access_token) {
      setLoading(true, "Just a second while we retrieve your information")
      try {
        const idaasTokenData = await getHeaderAccessToken(header_access_token)
        if (idaasTokenData.Status === undefined)
        if(idaasTokenData.Response)
        {
          setTokenDetails(idaasTokenData.Response)
         
          if(idaasTokenData.Response.access_token){
            const userdetails = await getUserDetails(idaasTokenData.Response.access_token);
            if (userdetails) {
              const data = JSON.parse(userdetails);
              setUserInfo(data);
            } else {
              console.error("Invalid idaasTokenData received:", idaasTokenData);
            }
          }
        // }
        const bauTokenData = await getBauAccessToken(idaasTokenData.Response.access_token)
        if (bauTokenData && bauTokenData.access_token) {
          // Update the state with the received token data
          setBauTokenDetails(bauTokenData);
          // Set the cookie with the access token (expires in 3600 seconds = 1 hour)
          Cookies.set("header_bau_token", bauTokenData.access_token, {
            expires: 3600,  // Expiry in seconds
          });


       } else {
          console.error("Invalid BAUTokenData received:", bauTokenData);
        } 
          const idaasTaasTokenData = await getHeaderTaasToken(idaasTokenData.Response.access_token)
          if (idaasTaasTokenData && idaasTaasTokenData.access_token) {
            // Update the state with the received token data
            setTaasTokenDetails(idaasTaasTokenData);
            // Set the cookie with the access token (expires in 3600 seconds = 1 hour)
            Cookies.set("header_tass_token", idaasTaasTokenData.access_token, {
              expires: 3600,  // Expiry in seconds
            });

          } else {
            console.error("Invalid idaasTokenData received:", idaasTaasTokenData);
          }  
      }  
      // }
      } catch (error) {
        console.log(error)
        logout()
      }

      setLoading(false, "")
    }
  }

  const updateTassDetails = async () => {
    if (tokenDetails?.access_token) {
      setLoading(true, "Just a second while we retrieve your information")
      try {
        const idaasTaasTokenData = await getHeaderTaasToken(tokenDetails?.access_token)

        if (idaasTaasTokenData && idaasTaasTokenData.access_token) {
          // Log the token to confirm
  
  
          // Update the state with the received token data
          setTaasTokenDetails(idaasTaasTokenData);
  
          // Set the cookie with the access token (expires in 3600 seconds = 1 hour)
          Cookies.set("header_tass_token", idaasTaasTokenData.access_token, {
            expires: 3600,  // Expiry in seconds
          });
  
          console.log("Cookie set with access_token");
        } else {
          console.error("Invalid idaasTokenData received:", idaasTaasTokenData);
        }
        const userdetails = await getUserDetails(tokenDetails?.access_token)
        if (userdetails) {
          setUserInfo(userdetails);
        } else {
          console.error("Invalid idaasTokenData received:", idaasTaasTokenData);
        }
      } catch (error) {
        console.log(error)
        logout()
      }
      setLoading(false, "")
    }
  }

  useEffect(() => {
    updateTokenDetails();
    updateTassDetails();
  }, [header_access_token])

  useEffect(() => {
    updateTassDetails()
  }, [header_access_token])

  const logout = useCallback(() => {
    Cookies.remove("header_access_token")
    Cookies.remove("npsSurvey")
    setTokenDetails(undefined)
    setToken(undefined)
    Cookies.remove("header_tass_token")
    Cookies.remove("header_bau_token")
    setTaasTokenDetails(undefined)
    setBauTokenDetails(undefined)
    setTass(undefined)
    setBauToken(undefined)
    setUserInfo(undefined)
  }, [])

  const updateToken = useCallback(() => {
    const getToken = Cookies.get("header_access_token")

    if (getToken) {
      setToken(getToken)
    }
  }, [])

  const updateTass = useCallback(() => {
    const getTaasToken = Cookies.get("header_tass_token")

    if (getTaasToken) {
      setTass(getTaasToken)
    }
  }, [])

  const context = React.useMemo(
    () => ({
      isLoggedIn: !!header_access_token,
      header_access_token,
      header_tass_token,
      header_bau_token,
      tokenDetails,
      login,
      logout,
      updateToken,
      updateTokenDetails,
      taasTokenDetails,
      bauTokenDetails,
      updateTassDetails,
      updateTass,
      userInfo
    }),
    [header_access_token, tokenDetails, header_tass_token, taasTokenDetails, bauTokenDetails, header_bau_token, userInfo]
  )
  return <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
}
